// extracted by mini-css-extract-plugin
module.exports = {"mapRightPanelPrimaryInfo":"primary-info_mobile_mapRightPanelPrimaryInfo__2ZIMp","primaryInfoImage":"primary-info_mobile_primaryInfoImage__D0q9p"};